let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7xv66"), load("3Eu7W"), load("4g8hn")]).then(() => parcelRequire('l2PDp'));